import config from '../config.json';

export function primaryLambdaGateway() {
	return config[process.env.REACT_APP_ENV].lambda.primaryLambdaGateway;
}
